import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, DoCheck, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SortPipe } from '../_helpers/sort.pipe';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import { appConfig, dev, int, intLan, intUrl, localUrl, opeUrl, share, shareLan, baseUrl, online, opewafUrl,opeNewwafUrl } from '../app.config';
import { CommonService } from '../_service/common.service';
import { PagerService } from '../_service/pager-service';
import * as XLSX from 'xlsx';
import { K2Service } from '../_service/K2.service';
import { SupplierService } from '../_service/supplier.service';
import { ArcaService } from '../_service/arca.service';
import { firstValueFrom } from 'rxjs';

const TWO = 2;
const SEVEN = 7;
const TEN = 10;
const THIRTY = 30;
const FIFTY = 50;
const THREE_HUNDRED = 300;
const FIVE_HUNDRED_FIFTY = 550;
const THREE_THOUSAND_MS = 3000;
const ONE_SECOND_MS = 1000;
const SECONDS_PER_HOUR = 3600;
const HOURS_PER_DAY = 24;
const HTTP_STATUS_NOT_FOUND = 404;

@Component({
    selector: 'app-workflow',
    templateUrl: './workflow.component.html',
    styleUrls: ['./workflow.component.css'],
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterLink, RouterModule,
        MatIconModule, MatFormFieldModule, MatInputModule, MatSelectModule,
        MatOptionModule, MatTooltipModule, MatProgressSpinnerModule,
        MatProgressBarModule, NgxPaginationModule, NgbModule, SortPipe,
        HelpsectionComponent, SuppliertabComponent
    ]
})
export class WorkflowComponent implements OnInit, DoCheck {
  Config: any;
  loading: boolean = false;
  loadData: boolean = false;

  public PageTotalLength: any = "";
  pager: any = {};

  public envHide: any = "";
  public customLoadingTemplate: any;
  public customLoadingTemplate2: any;
  public roleVariableHide = false;
  public prodHide = false;
  public superUserShow: any = false;
  public showBuyerProfile: any = false;
  public showForConsult = false;
  public showForSupplier: boolean = false;
  public roleIsManager: boolean = false;

  public companyNameModel: any = "";
  public workflowIdModel: any = "";
  public workFlowDetails: any = [];
  public Uid: any = '';
  identifierTypeModel: any = 'workflowId';

  pageHeight: number = 0;
  public colorForWorkflow = { "In progress": "#B7783C", "Need more info": "#66D8D0", "Approved": "#5CBA63", "Refused": "#CB4B32" }
  public statusOrder = ["In progress", "Need more info", "Approved", "Refused"];
  public showFilterStatus = false;
  public FiltercheckStatus = ["Inprogress_status", "Needmoreinfo_status", "Approved_status", "Refused_status"];
  public Approved_status: boolean = false; public Refused_status: boolean = false; public Inprogress_status: boolean = false; public Archived_status: boolean = false;
  public Needmoreinfo_status: boolean = false;
  public colors2 = [
    { status: "DELETED", color: "#CB4B32" },
    { status: "In progress", color: "#B7783C" },
    { status: "Need more info", color: "#66D8D0" },
    { status: "DRAFT", color: "yellow" },
    { status: "Approved", color: "#5CBA63" },
    { status: "Refused", color: "#CB4B32" },
    { status: "Updating...", color: "white" },
    { status: "Blocked", color: "#CB4B32" },
    { status: "Active", color: "#5CBA63" },
    { status: "Registered", color: "#66D8D0" },
    { status: "Prospect", color: "#4B9BF5" },
    { status: "Identified", color: "#D8C4A0" },
    { status: "", color: "white" }
  ];
  paginationForStatus: boolean = false;
  filteredCompanies: any = [];
  public siteRowIdFilter: any = [];
  public workflowStatus: any = [];
  paginationForworkflowStatus: boolean;
  paging: { totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number; endPage: number; startIndex: number; endIndex: number; pages: number[]; };
  // pager: any = {};
  workflowFolioFromK2Isa: any = '';
  workflowValidationLoading: boolean = false;
  wkfValNotesModel: any = '';
  confirmationOption: boolean = false;
  documentsReviewOption: boolean = false;
  reqType: string = '';
  tempWorkflow: any = [];
  statusFiltered: boolean = false;
  wkfRejNotesModel: any = '';
  wkfInfoNotesModel: any = '';
  public rejectWorkflowNotesError: boolean = false;
  maxRecorePage = FIFTY;
  requestForNotesHistory: any = [];
  workflowReqIdFromK2Isa: any = '';
  specificCpyLink: string = '';
  public mailBodyContent: string = `<p>Hello,</p><p>You have been designed by an Alliance Renault-Nissan buyer to complete several information that will allow you to begin business with the Renault Group.For that please access the following page ${this.specificCpyLink} and update the missing data listed on the top of the page. For any help please contact <u>isa@renault.com</u></p><p>Regards,</p><p>Supplier Admin</p>`;
  MailNameModel: string;
  differenceinDays: any;
  validatingWorkflow: boolean = false;
  workFlowData: any;
  workFlowExport: any;
  public personArray: any = [];
  key: string = 'name';
  reverse: boolean = false;
  history: any;
  histPager: any = {};
  approverEdit: boolean;
  sendMailToApprover: any;
  senReqNotesMOdel: any;
  arcasearchModel: string;
  senReqSamMOdel: string = '';
  senReqSamMOdelError: boolean;
  senReqBuyerAssiMOdel: string;
  buyerNameSelected: string;
  ArcIpn: string;
  ArcFirstName: string;
  ArcLastName: string;
  data: any[];
  resetArca: boolean;
  arcaSrchWait: boolean;
  arcaSrchnoresults: boolean;
  isaRoleFor_Uid: any[] = [];
  showUidDisable: boolean;
  isEnvQua: boolean;
  isEnvInt: boolean;
  allianceIdFromK2Isa: any;
  checkboxSelect: boolean;
  historyLoading: boolean;
  completedWrf: boolean = false;
  approverEmail: any;
  currentModalDetail: any;


  constructor(public commonService: CommonService, private supplierService: SupplierService, private k2Service: K2Service, private arcaService: ArcaService, private k2Socle: K2Service, private router: Router, private pagerService: PagerService, private http: HttpClient, private datePipe: DatePipe) {
    this.Config = appConfig;
  }

  ngOnInit() {
    this.getSearch()
  }

  ngDoCheck() {
    this.getRoles();
  }

  getRoles() {
    var RoleByService = this.commonService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  checkAllProfilesAndEnv(RoleByService) {
    let c = RoleByService;
    if (c['buyer'] === 'yes') {
      this.showBuyerProfile = false;
    } else {
      this.showBuyerProfile = true;
    }
    if (c['env'] === 'qua' || c['env'] === 're7' || c['env'] === 'ope') {
      this.envHide = false;
    } else {
      this.envHide = true;
    }
    if (c['role'] === 'admin' || c['role'].includes('admin')) {
      this.roleVariableHide = true;
    } else {
      this.roleVariableHide = false;
    }
    if (c['role'] === 'manager') {
      this.roleIsManager = true;
    } else {
      this.roleIsManager = false;
    }
    if (c['superAdmin'] === 'yes') {
      this.superUserShow = true;
    } else {
      this.superUserShow = false;
    }
    if (c['env'] === 'ope') {
      this.prodHide = true;
    } else {
      this.prodHide = false;
    }
    if (c['role'] === 'consult' || c['role'].includes('consult')) {
      this.showForConsult = false;
    } else {
      this.showForConsult = true;
    }
    if (c['role'] === 'consult' || c['role'].includes('consult')) {
      this.router.navigate(['/not-authorized']);
      return;
    }
    if (c['role'] === 'supplier') {
      this.showForSupplier = false;
    } else {
      this.showForSupplier = true;
    } if (c['env'] === 'qua') {
      this.isEnvQua = true;
    } else {
      this.isEnvQua = false;
    }
    if (c['env'] === 'int') {
      this.isEnvInt = true;
    } else {
      this.isEnvInt = false;
    }
  }

  clearFields(resetparam: any) {
    if (resetparam === "All") {
      this.companyNameModel = "";
      this.workFlowDetails = [];
      this.loadData = false;
      this.loading = false;
      this.workflowIdModel = "";
    } else if (resetparam === 'company') {
      this.companyNameModel = "";
    } else if (resetparam === 'workflowId') {
      this.workflowIdModel = "";
    }
  }

  async getSearch(page = 1) {
    this.workFlowDetails = [];
    this.tempWorkflow = [];
    this.paginationForStatus = false;
    this.requestForNotesHistory = [];
    this.Uid = this.commonService.fromApp_UserIPN.toLowerCase();
    let idpToken = localStorage.getItem('IDPAccessToken');
    let companyIds = [];
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    if (this.workflowIdModel.trim() === '' && this.companyNameModel.trim() === '') {
      this.loading = true;
      this.commonService.clearAllActiveTask();
      this.k2Socle.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
        this.commonService.setAllActiveTask(data1);


        this.k2Socle.getK2Isa(`${this.Config.ApiK2Url}isa`).subscribe(async data => {
          if (data['listRequestDetails'].length > 0) {
            let reqDetails = data['listRequestDetails']
            const commonRows = data1.filter(item1 =>
              reqDetails.some(item2 =>
                item1['folio'].includes(item2['folio'])
              )
            );
            console.info('commonRows', commonRows)
            const uniqueValues = Array.from(new Set(commonRows.map(item => item.locatedUser)));

            console.info(uniqueValues);
            await this.getPersonAsync(uniqueValues)
            console.info('personsget', this.personArray)
            await data['listRequestDetails'].reduce(async (promise, element) => {
              await promise;
              element['workflowOwnerWithRole'] = [];
              if (element['workflowOwner'] === undefined) {
                element['workflowOwner'] = [];
              }
              if (element['supplierDetail'].includes('company-details/')) {
                let id = element['supplierDetail'].split("company-details/");
                element['companyId'] = id[1].replace("'", '');
              }
              data1.forEach(async ele1 => {
                if (element['folio']) {
                  if (ele1['folio'].includes(element['folio'])) {
                    let workflowOwner = ele1['locatedUser'].split(":");
                    element['taskID'] = ele1['serialNumber']
                    element['folio'] = ele1['folio']

                    if (this.personArray.findIndex(x => x.Uid.toLowerCase() === workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()) === -1) {
                      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
                        if (data7 != null) {
                          this.personArray.push(data7)
                          if (data7['FirstName'] != undefined) {
                            element['workflowOwnerWithRole'].push(`${data7['FirstName']} ${data7['LastName']} - ${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase().toUpperCase()}`);
                          } else {
                            element['workflowOwnerWithRole'].push(workflowOwner[1]);
                          }
                        } else {
                          element['workflowOwnerWithRole'].push(workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase());
                        }
                      }, _err => {

                      });

                    } else {
                      let personIndex = this.personArray.findIndex(x => x.Uid.toLowerCase() === workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase())
                      if (this.personArray[personIndex]['FirstName'] != undefined && personIndex != -1) {
                        element['workflowOwnerWithRole'].push(`${this.personArray[personIndex]['FirstName']} ${this.personArray[personIndex]['LastName']} - ${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase().toUpperCase()}`);
                      } else {
                        element['workflowOwnerWithRole'].push(workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase());
                      }
                    }
                    let tem = workflowOwner[1].split("\\");
                    if (tem[1] === 'V033684') {
                      element['supportipn'] = true;
                    } else {
                      element['supportipn'] = false;
                    }
                    let tep = element['historys'].length > 0 ? element['historys'][element['historys'].length - 1]['date'] : '';
                    let date1;
                    if (tep != '' && tep != null) {
                      date1 = new Date(tep);
                    } else {
                      date1 = new Date(element.lastModificationDate);
                    }
                    let date2 = new Date();
                    let Difference_In_Time = date2.getTime() - date1.getTime();
                    let Difference_In_Days = Difference_In_Time / (ONE_SECOND_MS * SECONDS_PER_HOUR * HOURS_PER_DAY);
                    if (Difference_In_Days >= 1) {
                      element['difference'] = Difference_In_Days.toString().split('.')[0]
                      element['date'] = true;
                    } else {
                      element['date'] = false;
                    }
                    element['workflowOwner'].push(workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase());
                    if (element['allianceId'].toLowerCase().startsWith('cy') || element['allianceId'].toLowerCase().startsWith('cpy')) {
                      if (companyIds.indexOf(`'${element['allianceId']}'`) === -1) {
                        companyIds.push(`'${element['allianceId']}'`);
                      }
                    }
                  }
                }
              });
              if (element['requestor']['user'].toLowerCase().length === SEVEN) {
                if (this.personArray.findIndex(x => x.Uid.toLowerCase() === element['requestor']['user'].toLowerCase()) === -1) {
                  this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${element['requestor']['user']}')`).subscribe((data8: any) => {
                    if (data8 != null) {
                      this.personArray.push(data8)
                      if (data8['Mail'] != undefined && data8['Mail'] != '') {
                        element['RequestorMailId'] = data8['Mail'];
                      }
                    }
                  });
                } else {
                  let personIndex = this.personArray.findIndex(x => x.Uid.toLowerCase() === element['requestor']['user'].toLowerCase())
                  if (this.personArray[personIndex]['Mail'] != undefined && this.personArray[personIndex]['Mail'] != '') {
                    element['RequestorMailId'] = this.personArray[personIndex]['Mail'];
                  }
                }
              } else {
                console.info('requestor user is not 7 characters ', element['requestor']['user'])
              }
              this.siteRowIdFilter.push(element.requestId);
              this.tempWorkflow.push(element);
              element['filterTrue'] = true;
              if (this.workflowStatus[element.requestId] === undefined) {
                this.workflowStatus[element.requestId] = [];
              }
              if (this.workflowStatus[element.requestId]) {
                this.workflowStatus[element.requestId] = [element.status]
              }


            }, Promise.resolve());
            this.workFlowDetails = this.tempWorkflow
            console.info(this.workFlowDetails)
            this.loadData = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.loadData = false;
          }
          let len = this.workFlowDetails.length;
          this.PageTotalLength = len;
          if (len <= TEN) {
            this.pageHeight = len * THIRTY + THREE_HUNDRED;
          } else {
            this.pageHeight = FIVE_HUNDRED_FIFTY;
          }
          this.workFlowExport = this.workFlowDetails;
          const sorted = this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
          this.pager = this.pagerService.getPager(this.workFlowDetails.length, page, FIFTY);
          this.workFlowDetails = this.workFlowDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
        }, error => {
          console.info('error', error);
        });
        // }
      }, error => {
        console.info('error', error);
      });
    } else if (this.workflowIdModel.trim() != '' && this.companyNameModel.trim() === '') {
      let fitered = []
      this.loading = true;
      this.commonService.clearAllActiveTask();
      this.k2Socle.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
        this.commonService.setAllActiveTask(data1);
        this.k2Socle.getK2Isa(`${this.Config.ApiK2Url}isa`).subscribe(async data => {

          let reqDetails = data['listRequestDetails']
          const commonRows = data1.filter(item1 =>
            reqDetails.some(item2 =>
              item1['folio'].includes(item2['folio'])
            )
          );
          console.info('commonRows', commonRows)
          const uniqueValues = Array.from(new Set(commonRows.map(item => item.locatedUser)));

          console.info(uniqueValues);
          await this.getPersonAsync(uniqueValues)
          fitered = data['listRequestDetails'].filter(d1 => { return d1.requestId.toString().includes(this.workflowIdModel.trim()) });
          console.info("fi", fitered)
          if (fitered.length > 0) {
            fitered.forEach(element => {
              element['workflowOwnerWithRole'] = [];
              if (element['workflowOwner'] === undefined) {
                element['workflowOwner'] = [];
              }
              if (element['supplierDetail'].includes('company-details/')) {
                let id = element['supplierDetail'].split("company-details/");
                element['companyId'] = id[1].replace("'", '');
              }
              data1.forEach(ele1 => {
                if (element['folio']) {
                  if (ele1['folio'].includes(element['folio'])) {
                    let workflowOwner = ele1['locatedUser'].split(":");
                    element['taskID'] = ele1['serialNumber']
                    if (this.personArray.findIndex(x => x.Uid.toLowerCase() === workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()) === -1) {

                      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
                        if (data7 != null) {
                          this.personArray.push(data7)
                          if (data7['FirstName'] != undefined) {
                            element['workflowOwnerWithRole'].push(`${data7['FirstName']} ${data7['LastName']} - ${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase().toUpperCase()}`);
                          } else {
                            element['workflowOwnerWithRole'].push(workflowOwner[1]);
                          }
                        } else {
                          element['workflowOwnerWithRole'].push(workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase());
                        }
                      });
                    } else {
                      let personIndex = this.personArray.findIndex(x => x.Uid.toLowerCase() === element['requestor']['user'].toLowerCase())
                      if (this.personArray[personIndex]['FirstName'] != undefined) {
                        element['workflowOwnerWithRole'].push(`${this.personArray[personIndex]['FirstName']} ${this.personArray[personIndex]['LastName']} - ${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase().toUpperCase()}`);
                      } else {
                        element['workflowOwnerWithRole'].push(workflowOwner[1]);
                      }
                    }
                    let tem = workflowOwner[1].split("\\");
                    console.info("tem", tem[1])
                    if (tem[1] === 'V033684') {
                      element['supportipn'] = true;
                    } else {
                      element['supportipn'] = false;
                    }
                    let tep = element['historys'].length > 0 ? element['historys'][element['historys'].length - 1]['date'] : '';
                    if (tep != '' && tep != null) {
                      var date1 = new Date(tep);
                    } else {
                      var date1 = new Date(element.lastModificationDate);
                    }
                    let date2 = new Date();
                    let Difference_In_Time = date2.getTime() - date1.getTime();
                    let Difference_In_Days = Difference_In_Time / (ONE_SECOND_MS * SECONDS_PER_HOUR * HOURS_PER_DAY);
                    if (Difference_In_Days >= 1) {
                      element['difference'] = Difference_In_Days.toString().split('.')[0]
                      element['date'] = true;
                    } else {
                      element['date'] = false;
                    }
                    element['workflowOwner'].push(workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase());
                    if (element['allianceId'].toLowerCase().startsWith('cy') || element['allianceId'].toLowerCase().startsWith('cpy')) {
                      if (companyIds.indexOf(`'${element['allianceId']}'`) === -1) {
                        companyIds.push(`'${element['allianceId']}'`);
                      }
                    }
                  }
                }
              });
              if (element['requestor']['user'].toLowerCase().length === SEVEN) {
                if (this.personArray.findIndex(x => x.Uid.toLowerCase() === element['requestor']['user'].toLowerCase()) === -1) {

                  this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${element['requestor']['user']}')`).subscribe((data8: any) => {
                    if (data8 != null) {
                      this.personArray.push(data8)
                    }
                    if (data8['Mail'] != undefined && data8['Mail'] != '') {
                      element['RequestorMailId'] = data8['Mail'];
                    }
                  });
                } else {
                  let personIndex = this.personArray.findIndex(x => x.Uid.toLowerCase() === element['requestor']['user'].toLowerCase())
                  if (this.personArray[personIndex]['Mail'] != undefined && this.personArray[personIndex]['Mail'] != '') {
                    element['RequestorMailId'] = this.personArray[personIndex]['Mail'];
                  }
                }
              } else {
                console.info('requestor user is not 7 characters ', element['requestor']['user'])
              }
              this.siteRowIdFilter.push(element.requestId);
              this.tempWorkflow.push(element);
              element['filterTrue'] = true;
              if (this.workflowStatus[element.requestId] === undefined) {
                this.workflowStatus[element.requestId] = [];
              }
              if (this.workflowStatus[element.requestId]) {
                this.workflowStatus[element.requestId] = [element.status]
              }
            });
            this.workFlowDetails = this.tempWorkflow;
            this.loadData = true;
            this.loading = false;
          }
          else {
            this.loading = false;
            this.loadData = false;
          }
          let len = this.workFlowDetails.length;
          this.PageTotalLength = len;
          if (len <= TEN) {
            this.pageHeight = len * THIRTY + THREE_HUNDRED;
          } else {
            this.pageHeight = FIVE_HUNDRED_FIFTY;
          }
          const sorted = this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
          this.pager = this.pagerService.getPager(this.workFlowDetails.length, page, FIFTY);
          this.workFlowDetails = this.workFlowDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
        }, error => {
          console.info('error', error);
        });
      });
    } else if (this.workflowIdModel.trim() === '' && this.companyNameModel.trim() != '') {
      let fitered = []
      this.loading = true;
      this.commonService.clearAllActiveTask();
      this.k2Socle.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
        this.commonService.setAllActiveTask(data1);
        this.commonService.allActiveTask.push(...data1);
        this.k2Socle.getK2Isa(`${this.Config.ApiK2Url}isa`).subscribe(async data => {
          let reqDetails = data['listRequestDetails']
          const commonRows = data1.filter(item1 =>
            reqDetails.some(item2 =>
              item1['folio'].includes(item2['folio'])
            )
          );
          console.info('commonRows', commonRows)
          const uniqueValues = Array.from(new Set(commonRows.map(item => item.locatedUser)));

          console.info(uniqueValues);
          await this.getPersonAsync(uniqueValues)
          fitered = data['listRequestDetails'].filter(d1 => { return d1.supplierName.includes(this.companyNameModel.trim()) });
          if (fitered.length > 0) {
            fitered.forEach(element => {
              element['workflowOwnerWithRole'] = [];
              if (element['workflowOwner'] === undefined) {
                element['workflowOwner'] = [];
              }
              if (element['supplierDetail'].includes('company-details/')) {
                let id = element['supplierDetail'].split("company-details/");
                element['companyId'] = id[1].replace("'", '');
              }
              data1.forEach(ele1 => {
                if (element['folio']) {
                  if (ele1['folio'].includes(element['folio'])) {
                    let workflowOwner = ele1['locatedUser'].split(":");
                    if (this.personArray.findIndex(x => x.Uid.toLowerCase() === workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()) === -1) {

                      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
                        if (data7 != null) {
                          this.personArray.push(data7)

                          if (data7['FirstName'] != undefined) {
                            element['workflowOwnerWithRole'].push(`${data7['FirstName']} ${data7['LastName']} - ${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase().toUpperCase()}`);
                          } else {
                            element['workflowOwnerWithRole'].push(workflowOwner[1]);
                          }
                        } else {
                          element['workflowOwnerWithRole'].push(workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase());
                        }
                      });
                    } else {
                      let personIndex = this.personArray.findIndex(x => x.Uid.toLowerCase() === element['requestor']['user'].toLowerCase())
                      if (personIndex != -1) {
                        if (this.personArray[personIndex]['FirstName'] != undefined) {
                          element['workflowOwnerWithRole'].push(`${this.personArray[personIndex]['FirstName']} ${this.personArray[personIndex]['LastName']} - ${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase().toUpperCase()}`);
                        }
                      } else {
                        element['workflowOwnerWithRole'].push(workflowOwner[1]);
                      }
                    }
                    let tem = workflowOwner[1].split("\\");
                    console.info("tem", tem[1])
                    if (tem[1] === 'V033684') {
                      element['supportipn'] = true;
                    } else {
                      element['supportipn'] = false;
                    }
                    let tep = element['historys'].length > 0 ? element['historys'][element['historys'].length - 1]['date'] : '';
                    if (tep != '' && tep != null) {
                      var date1 = new Date(tep);
                    } else {
                      var date1 = new Date(element.lastModificationDate);
                    }
                    let date2 = new Date();
                    let Difference_In_Time = date2.getTime() - date1.getTime();
                    let Difference_In_Days = Difference_In_Time / (ONE_SECOND_MS * SECONDS_PER_HOUR * HOURS_PER_DAY);
                    if (Difference_In_Days >= 1) {
                      element['difference'] = Difference_In_Days.toString().split('.')[0]
                      element['date'] = true;
                    } else {
                      element['date'] = false;
                    }
                    element['workflowOwner'].push(workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase());
                    if (element['allianceId'].toLowerCase().startsWith('cy') || element['allianceId'].toLowerCase().startsWith('cpy')) {
                      if (companyIds.indexOf(`'${element['allianceId']}'`) === -1) {
                        companyIds.push(`'${element['allianceId']}'`);
                      }
                    }
                  }
                }
              });
              if (element['requestor']['user'].toLowerCase().length === SEVEN) {
                if (this.personArray.findIndex(x => x.Uid.toLowerCase() === element['requestor']['user'].toLowerCase()) === -1) {

                  this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${element['requestor']['user']}')`).subscribe((data8: any) => {
                    if (data8 != null) {
                      this.personArray.push(data8)
                      if (data8['Mail'] != undefined && data8['Mail'] != '') {
                        element['RequestorMailId'] = data8['Mail'];
                      }
                    }
                  });
                } else {
                  let personIndex = this.personArray.findIndex(x => x.Uid.toLowerCase() === element['requestor']['user'].toLowerCase())
                  if (this.personArray[personIndex]['Mail'] != undefined && this.personArray[personIndex]['Mail'] != '') {
                    element['RequestorMailId'] = this.personArray[personIndex]['Mail'];
                  }
                }
              } else {
                console.info('requestor user is not 7 characters ', element['requestor']['user'])
              }
              this.siteRowIdFilter.push(element.requestId);
              this.tempWorkflow.push(element);
              element['filterTrue'] = true;
              if (this.workflowStatus[element.requestId] === undefined) {
                this.workflowStatus[element.requestId] = [];
              }
              if (this.workflowStatus[element.requestId]) {
                this.workflowStatus[element.requestId] = [element.status]
              }
            });
            this.workFlowDetails = this.tempWorkflow;
            this.loadData = true;
            this.loading = false;
          }
          else {
            this.loading = false;
            this.loadData = false;
          }
          let len = this.workFlowDetails.length;
          this.PageTotalLength = len;
          if (len <= TEN) {
            this.pageHeight = len * THIRTY + THREE_HUNDRED;
          } else {
            this.pageHeight = FIVE_HUNDRED_FIFTY;
          }
          const sorted = this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
          this.pager = this.pagerService.getPager(this.workFlowDetails.length, page, FIFTY);
          this.workFlowDetails = this.workFlowDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
        }, error => {
          console.info('error', error);
        });
      });
    }
  }
  async getPersonAsync(persons) {
    for (const person of persons) {
      let workflowOwner = person.split(":");

      if (this.personArray.findIndex(x => x.Uid.toLowerCase() === workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()) === -1) {
        try {
          const data = await firstValueFrom(this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()}')`));
          if (data != null) {
            this.personArray.push(data);
          }
          console.info('this.personArray1', this.personArray);
        } catch (err) {

        }
      }
    }
  }
  getCompaniesList(companyIds, page = 1) {
    if (companyIds.length > 0) {
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=in(${companyIds})&_page=${page}`).subscribe(data => {
        if (data['companies'].length > 0) {
          data['companies'].forEach(e => {
            this.workFlowDetails.forEach(element => {
              if (element.allianceId === e.allianceIdentifier) {
                element['companyId'] = e.rowId;
              }
            });
            this.tempWorkflow.forEach(element => {
              if (element.allianceId === e.allianceIdentifier) {
                element['companyId'] = e.rowId;
              }
            });
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getCompaniesList(companyIds, page + 1);
          } else if (data['maxPage'] === page) {
            this.loadData = true;
            this.loading = false;
          }
        } else {
          this.loading = false;
          this.loadData = true;
        }
      });
    } else {
      this.loadData = true;
      this.loading = false;
    }
  }

  openWorkflow(id) {
    let baseUrl1 = baseUrl
    if (baseUrl1 === opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl) {
      window.open(shareLan + id);
    }
    else if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/` || baseUrl1 === intUrl) {
      window.open(`${dev}Consult/?&language=EN&requestid=${id}`);
    }
    else {
      window.open(intLan + id);
    }
  }

  openK2Website() {
    let baseUrl1 = baseUrl
    if (baseUrl1 === opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl) {
      window.open(`${share}HOME`);
    }
    else if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/` || baseUrl1 === intUrl) {
      window.open(`${dev}HOME`);
    }
    else {
      window.open(`${int}HOME`);
    }
  }

  pageHeightStyle() {
    if (this.loadData === true && this.workFlowDetails.length > 0) {
      let myStyleClass = {
        'height': `${this.pageHeight}px`,
        'overflow-y': 'scroll'
      };
      return myStyleClass;
    } else if (this.workFlowDetails.length === 0) {
      let myStyleClass = {
        'height': '200px'
      };
      return myStyleClass;
    }
  }

  getColor2(status) {
    let flag = 1;
    for (let i = 0; i < this.colors2.length; i++) {
      if (this.colors2[i].status === status) {
        flag = TWO
        return this.colors2.filter(item => item.status === status)[0].color;
      }
    }
    if (flag === 1) {
      return "#FFBD69";
    }
  }

  showDropdownStatus(dos = 'main') {
    if (dos === 'close') {
      this.FiltercheckStatus.forEach(ele => {
        this[ele] = false;
      });
    } else {
      this.showFilterStatus = !this.showFilterStatus;
    }
    setTimeout(function () {
      this.FiltercheckStatus.forEach(ele => {
        let type = ele.split('_');
        if (this[ele] === true) {
          document.getElementById(type[0]).setAttribute('checked', '');
        } else {
          document.getElementById(type[0]).removeAttribute('checked');
        }
      });
      if (dos === 'close') {
        this.filterStatus();
      }
    }.bind(this), TEN)
  }

  setCheckboxVal(status) {
    this[`${status}_status`] = !this[`${status}_status`];
  }

  filterStatus() {
    let statusToFilter = [];
    let validsiteIds = [];
    this.filteredCompanies = [];
    this.workFlowDetails = [];
    this.statusFiltered = false;
    this.FiltercheckStatus.forEach(ele => {
      if (this[ele] === true) {
        let type = ele.split('_');
        this.statusFiltered = true;
        if (type[0] === 'Inprogress') {
          statusToFilter.push('In progress')
        } else if (type[0] === 'Needmoreinfo') {
          statusToFilter.push('Need more info')
        }
        else {
          statusToFilter.push(type[0]);
        }
      }
    });
    console.info("status", statusToFilter)
    this.workFlowDetails = this.tempWorkflow;
    if (statusToFilter.length > 0) {
      this.siteRowIdFilter.forEach(element => {
        for (let i = 0; i < statusToFilter.length; i++) {
          for (let j = 0; j < this.workflowStatus[element].length; j++) {
            if (this.workflowStatus[element]) {
              if (statusToFilter[i] === this.workflowStatus[element][j]) {
                if (validsiteIds.indexOf(element) === -1) {
                  validsiteIds.push(element);
                }
              }
            }
          }
        }
      });
      this.workFlowDetails.forEach(elements => {
        if (validsiteIds.indexOf(elements.requestId) != -1) {
          elements['filterTrue'] = true;
          this.filteredCompanies.push(elements);
        } else {
          elements['filterTrue'] = false;
        }
      });
      this.paginationForStatus = true;
      this.PageTotalLength = this.filteredCompanies.length;
      const sorted = this.filteredCompanies.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
      this.pager = this.pagerService.getPager(this.filteredCompanies.length, 1, FIFTY);
      this.workFlowDetails = this.filteredCompanies.slice(this.pager.startIndex, this.pager.endIndex + 1);
      let len = this.filteredCompanies.length;
      if (len <= TEN) {
        this.pageHeight = len * THIRTY + THREE_HUNDRED;
      } else {
        this.pageHeight = FIVE_HUNDRED_FIFTY;
      }
    } else {
      this.workFlowDetails.forEach(e => {
        e['filterTrue'] = true;
        this.filteredCompanies.push(e);
      });
      this.paginationForStatus = true;
      this.PageTotalLength = this.filteredCompanies.length;
      const sorted = this.filteredCompanies.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
      this.pager = this.pagerService.getPager(this.filteredCompanies.length, 1, FIFTY);
      this.workFlowDetails = this.filteredCompanies.slice(this.pager.startIndex, this.pager.endIndex + 1);
      let len = this.workFlowDetails.length;
      if (len <= TEN) {
        this.pageHeight = len * THIRTY + THREE_HUNDRED;
      } else {
        this.pageHeight = FIVE_HUNDRED_FIFTY;
      }
    }
    this.showFilterStatus = false;
  }

  setPage(page) {
    this.PageTotalLength = this.filteredCompanies.length;
    this.pager = this.pagerService.getPager(this.filteredCompanies.length, page, FIFTY);
    this.workFlowDetails = this.filteredCompanies.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  loadWorkflowValidation(type, folio, reqId, allianceId, reqType, validator) {
    this.validatingWorkflow = false;
    if (type === 'valid') {
      this.wkfValNotesModel = '';
      this.confirmationOption = false;
      this.documentsReviewOption = false;
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
      this.allianceIdFromK2Isa = allianceId;
      this.reqType = reqType;
      this.checkboxSelect = (validator === 'Manager' && reqType === '1-New Supplier Referencing') ? true : false;
    } else if (type === 'reject') {
      this.wkfRejNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
      this.rejectWorkflowNotesError = false;
    } else if (type === 'info') {
      this.wkfInfoNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
    }
  }

  resetWkfValNotesModel() {
    this.wkfValNotesModel = '';
    this.confirmationOption = false;
    this.documentsReviewOption = false;
  }

  isValidationFormComplete(): boolean {
    if (this.reqType === '1-New Supplier Referencing' && this.checkboxSelect) {
      return this.confirmationOption === true && this.documentsReviewOption === true;
    }
    return true;
  }

  shouldShowCheckboxes(): boolean {
    if (this.reqType === '1-New Supplier Referencing') {

    }
    return false;
  }

  validateWkfNoteRoute() {
    this.validatingWorkflow = true;
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.commonService.clearAllActiveTask();
    this.k2Socle.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      let dataPresent = false
      this.commonService.setAllActiveTask(data1);
      if (data1.length > 0) {
        data1.forEach(ele1 => {
          if (this.workflowFolioFromK2Isa) {
            if (ele1['folio'].includes(this.workflowFolioFromK2Isa)) {
              dataPresent = true
              let serialNumber = ele1['serialNumber'];
              let workflowOwner = ele1['locatedUser'].split(":");
              let temp = workflowOwner[1].split("\\");
              if (temp[1].toLowerCase() === this.Uid) {
                let domain = temp[0];
                let note = this.wkfValNotesModel;

                let encoded = encodeURIComponent(note);
                this.k2Socle.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=Submit&domain=${domain}`, {}).subscribe(_data => { //doubt
                  this.workflowValidationLoading = true;
                  if (this.workflowFolioFromK2Isa.includes('Prospect')) {
                    this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status?code=Prospect`).subscribe((data: any) => {
                      let datas2 = {
                        "companyStatusCode": 'Prospect',
                        "companyStatusId": data['company-status'][0].row_id,
                      };
                      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=${this.allianceIdFromK2Isa}`).subscribe((cmpData: any) => {
                        this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${cmpData['companies'][0].rowId}`, datas2).subscribe((_data: any) => {
                        })
                      })
                    })
                  }
                  setTimeout(() => {
                    this.sendMailToRequestor(this.workflowFolioFromK2Isa, note)
                    this.sendRequestForMailToApp(this.workflowFolioFromK2Isa, note);
                  }, THREE_THOUSAND_MS);
                });
              }
            }
          }
        });
        if (!dataPresent) {
          setTimeout(() => {
            this.validateWkfNoteRoute();
          }, THREE_THOUSAND_MS)
        }
      }
    }, error => {
      console.info('error', error);
    });
  }


  sendMailToRequestor(folio, notes) {
    let baseUrl1 = baseUrl
    let style = "font-weight-bold text-warning"
    let mailSubject = `${this.commonService.mailSub}Approval request for `;
    let onlineHelp = online
    this.Uid = this.commonService.fromApp_UserIPN.toLowerCase();
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    let changed = folio.match(/^(.*_)(\d.*)$/);

    this.k2Socle.getK2Isa(`${this.Config.ApiK2Url}isa`).subscribe(data => {
      const list = data['listRequestDetails']
      const current_WrkFlow = list.filter(x => x.folio.includes(changed[1]))[0]
      let requestedUser = current_WrkFlow.requestor;

      if (current_WrkFlow.status.toLowerCase() === 'approved' || current_WrkFlow.status.toLowerCase() === 'refused') {
        this.completedWrf = true
        this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${current_WrkFlow.allianceId}*&_page= 1&_pagesize= 20`).subscribe(companyData => {
          let specificLink = `${baseUrl1}/company-details/${companyData['companies'][0].rowId}#workflows`;
          if (this.personArray.findIndex(x => x.Uid.toLowerCase() === requestedUser.user.toLowerCase()) === -1) {

            this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${requestedUser.user}')`).subscribe((reqUser: any) => {
              if (reqUser != null) {
                this.personArray.push(reqUser);
              }
              console.info('personarray7', this.personArray)
              if (current_WrkFlow.status.toLowerCase() === 'approved') {
                mailSubject = `${this.commonService.mailSub}Request approved for ${companyData['companies'][0].legalName}`;;

                this.mailBodyContent =
                  `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} was approved by the all validators! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from last approver : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
              }
              if (current_WrkFlow.status.toLowerCase() === 'refused') {
                mailSubject = `${this.commonService.mailSub}Request refused for ${companyData['companies'][0].legalName}`;

                this.mailBodyContent =
                  `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} was refused! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from the rejector : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
              }
              this.sendMailFn(reqUser.Mail, mailSubject, this.mailBodyContent, true);
            })
          } else {
            let personIndex = this.personArray.findIndex(x => x.Uid.toLowerCase() === requestedUser.user.toLowerCase())
            let reqUser = this.personArray[personIndex]
            if (current_WrkFlow.status.toLowerCase() === 'approved') {
              mailSubject = `${this.commonService.mailSub}Request approved for ${companyData['companies'][0].legalName}`;;

              this.mailBodyContent =
                `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} was approved by the all validators! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from last approver : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
            }
            if (current_WrkFlow.status.toLowerCase() === 'refused') {
              mailSubject = `${this.commonService.mailSub}Request refused for ${companyData['companies'][0].legalName}`;

              this.mailBodyContent =
                `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} was refused! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from the rejector : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
            }
            this.sendMailFn(reqUser.Mail, mailSubject, this.mailBodyContent, true);
          }
        })

      }
    })


  }

  sendRequestForMailToApp(folio = {}, notes = '') {
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.commonService.clearAllActiveTask();
    this.k2Socle.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      this.commonService.setAllActiveTask(data1);
      let mailFolio = false
      if (data1.length > 0) {
        this.k2Socle.getK2IsabyId(`${this.Config.ApiK2Url}isa/${this.workflowReqIdFromK2Isa}`).subscribe(data => {
          data1.forEach(ele1 => {
            if (data['folio']) {
              if (ele1['folio'].includes(data['folio'])) {
                mailFolio = true
                let workflowOwner = ele1['locatedUser'].split(":");
                if (this.personArray.findIndex(x => x.Uid.toLowerCase() === workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()) === -1) {

                  this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
                    if (data7 != null) {
                      this.personArray.push(data7);
                    }
                    console.info('personarray5', this.personArray)
                    let workflowOwnerName = '';
                    let workflowOwnerMailId = '';
                    if (data7['FirstName'] != undefined) {
                      workflowOwnerName = `${data7['FirstName']} ${data7['LastName']}`;
                    } else {
                      workflowOwnerName = workflowOwner[1];
                    }
                    if (data7['Mail'] != undefined && data7['Mail'] != '') {
                      workflowOwnerMailId = data7['Mail'];
                    }
                    let sendMailTo = workflowOwnerMailId;
                    let mailSubject = `${this.commonService.mailSub}Approval request for ${data['supplierName']}`;
                    let onlineHelp = online
                    let style = "font-weight-bold text-warning"
                    let desc: string
                    if (data['historys'].length === 0) {
                      desc = data['comment'];
                    } else if (data['historys'].length > 0) {
                      desc = data['historys'][data['historys'].length - 1]['route'].trim() != "Submitted" ?
                        data['historys'][data['historys'].length - 1]['comment'] : data['historys'][data['historys'].length - 2]['comment']
                    }
                    let baseUrl1 = baseUrl
                    let roleTemp;
                    if (data['validatorRole'] != null || data['validatorRole'] != '') {
                      roleTemp = ` as ${data['validatorRole']}`;
                    } else {
                      roleTemp = '';
                    }
                    this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${data['allianceId']}*&_page= 1&_pagesize= 20`).subscribe(companyData => {
                      let specificLink = `${baseUrl1}/company-details/${companyData['companies'][0].rowId}#workflows`;

                      this.mailBodyContent =
                        `<p>Hello ${workflowOwnerName},</p><p> The request ${data['folio']} (${data['strRequestType']}) is waiting for your validation${roleTemp}! </p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from previous approver : </p><p>${desc}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
                      this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent, true);
                    });
                  });
                } else {
                  let personIndex = this.personArray.findIndex(x => x.Uid.toLowerCase() === workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase())
                  let data7 = this.personArray[personIndex]
                  console.info('personarray5', this.personArray)
                  let workflowOwnerName = '';
                  let workflowOwnerMailId = '';
                  if (data7['FirstName'] != undefined) {
                    workflowOwnerName = `${data7['FirstName']} ${data7['LastName']}`;
                  } else {
                    workflowOwnerName = workflowOwner[1];
                  }
                  if (data7['Mail'] != undefined && data7['Mail'] != '') {
                    workflowOwnerMailId = data7['Mail'];
                  }
                  let sendMailTo = workflowOwnerMailId;
                  let mailSubject = `${this.commonService.mailSub}Approval request for ${data['supplierName']}`;
                  let onlineHelp = online
                  let style = "font-weight-bold text-warning"
                  let desc: string
                  if (data['historys'].length === 0) {
                    desc = data['comment'];
                  } else if (data['historys'].length > 0) {
                    desc = data['historys'][data['historys'].length - 1]['route'].trim() != "Submitted" ?
                      data['historys'][data['historys'].length - 1]['comment'] : data['historys'][data['historys'].length - 2]['comment']
                  }
                  let baseUrl1 = baseUrl
                  let roleTemp;
                  if (data['validatorRole'] != null || data['validatorRole'] != '') {
                    roleTemp = ` as ${data['validatorRole']}`;
                  } else {
                    roleTemp = '';
                  }
                  this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${data['allianceId']}*&_page= 1&_pagesize= 20`).subscribe(companyData => {
                    let specificLink = `${baseUrl1}/company-details/${companyData['companies'][0].rowId}#workflows`;

                    this.mailBodyContent =
                      `<p>Hello ${workflowOwnerName},</p><p> The request ${data['folio']} (${data['strRequestType']}) is waiting for your validation${roleTemp}! </p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from previous approver : </p><p>${desc}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
                    this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent, true);
                  });
                }
              }
            }
          });
          if (data['status'] !== 'Refused' && data['status'] !== 'Approved') {
            if (!mailFolio) {
              setTimeout(() => {
                console.info('loop Called')
                this.sendRequestForMailToApp()
              }, THREE_THOUSAND_MS)
            } else {
              this.validatingWorkflow = false
            }
          } else {
            if (!this.completedWrf) {
              console.info('loop for completed workflow')
              this.sendMailToRequestor(folio, notes)
            }
          }
        }, error => {
          console.info('error', error);
        });
      }
    }, error => {
      console.info('error', error);
    });
  }

  focusFunction(field) {
    if (field === 'sam' && this.senReqSamMOdel === '') {
      this.lookupArca('sam');
      document.getElementById('btnForArcaPopup').click();
    }
  }
  sendToNewApprover(data, newowner) {
    let destination = newowner.split('  -  ');
    let letters = ['f', 'F']

    let originalWorkflowOwner = data['workflowOwnerWithRole'] && data['workflowOwnerWithRole'][0] ? data['workflowOwnerWithRole'][0] : '';
    if (data['workflowOwnerWithRole'] && data['workflowOwnerWithRole'][0]) {
      let parts = data['workflowOwnerWithRole'][0].split(' - ');
      if (parts.length > 1) {
        originalWorkflowOwner = parts[parts.length - 1].trim();
      }
    }

    let originalDomain = letters.some(letter => originalWorkflowOwner.includes(letter)) ? "EXTALLIANCEIT" : "CORP";
    let destinationDomain = letters.some(letter => destination[0].includes(letter)) ? "EXTALLIANCEIT" : "CORP";
    const newData = ''
    console.info('data', newData);
    console.info('originalWorkflowOwner extracted:', originalWorkflowOwner);

    this.k2Service.createK2Isa(`${this.Config.ApiK2Url}redirect-tasks?taskID=${data['taskID']}&destinationDN=${destination[0]}&originalIpn=${originalWorkflowOwner}&destinationIpn=${destination[0]}&originalDomain=${originalDomain}&destinationDomain=${destinationDomain}`, newData).subscribe(_data1 => {
      console.info("send Mail");


      let sendMailTo = this.sendMailToApprover
      var desc = this.senReqNotesMOdel;
      let baseUrl1 = baseUrl
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${data['allianceId']}*&_page= 1&_pagesize= 20`).subscribe(companyData => {
        let specificLink = `${baseUrl1}/company-details/${companyData['companies'][0].rowId}#workflows`;

        let mailSubject = `${this.commonService.mailSub}Approval request for ${data.supplierName}`;
        let onlineHelp = online
        this.mailBodyContent =
          `<p>Dear ${destination[1]} ${destination[2]},</p><p> You have been designed as new approver of the request ${data['folio']}</p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p><p>Notes from the Admin Team:</p> <p>${desc}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
        this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent, true);
      });
    })
  }
  PasteSam(ipn, firstName, lastName, mail) {
    this.sendMailToApprover = mail;
    if (this.arcasearchModel === 'sam') {
      this.senReqSamMOdel = `${ipn}  -  ${firstName}  -  ${lastName}`;
      this.senReqSamMOdelError = false;
    }
    if (this.arcasearchModel === 'buyeraasis') {
      this.senReqBuyerAssiMOdel = `${ipn}  -  ${firstName}  -  ${lastName}`;
      this.buyerNameSelected = `${firstName} ${lastName}`;
    }
    window.document.getElementById("closeGCBtn").click();
  }
  ArcNameModelChange() {
    this.data = [];
    this.resetArca = false;
    this.arcaSrchWait = false;
    this.arcaSrchnoresults = false;
  }
  resetArcaSearch(val) {
    if (val === "ArcIpn") {
      this.ArcIpn = '';
    } else if (val === "ArcFirstName") {
      this.ArcFirstName = '';
    } else if (val === "ArcLastName") {
      this.ArcLastName = '';
    }
  }
  ArcSearch() {
    var FilterParam = "";
    let firstAndLast = false;
    if (this.ArcFirstName != "" && this.ArcLastName === "") {
      FilterParam += `contains(FirstName,'${this.ArcFirstName}') `;
    } else if (this.ArcFirstName === "" && this.ArcLastName != "") {
      FilterParam += `contains(LastName,'${this.ArcLastName}') `;
    }
    if (this.ArcLastName != "") {
      if (this.ArcFirstName != "") {
        firstAndLast = true;
        FilterParam += `contains(FirstName,'${this.ArcFirstName}') `;
      }
    }
    if (this.ArcIpn != "") {
      if (this.ArcFirstName != "" || this.ArcLastName != "") {
      }
    }
    let sam_arr: any = []

    if (FilterParam != "" && firstAndLast === false) {

      this.arcaSrchnoresults = false;
      this.arcaSrchWait = true;
      this.isaRoleFor_Uid = [];
      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person?$filter=${FilterParam}&$select=Uid,CommonName,FirstName,LastName,Mail,PersonSuperDomainCode&$top=10`).subscribe(data => {
        if (data ? data['value'].length > 0 : false) {
          if (data['value'].length > 0) {
            if (this.arcasearchModel === 'sam' || this.arcasearchModel === 'buyeraasis') {
              data['value'].forEach(e => {
                if (e.PersonSuperDomainCode === 'renault' || e.PersonSuperDomainCode === 'nna' || e.PersonSuperDomainCode === 'ne' || e.PersonSuperDomainCode === 'nml') {
                  sam_arr.push(e);
                  if (this.showUidDisable === false && this.isEnvQua === false && this.isEnvInt === false) {
                    this.getArcaUserIsaRole(e.Uid);
                  } else if (this.isEnvQua === true || this.isEnvInt === true) {
                    this.isaRoleFor_Uid[e.Uid] = 'manager';
                  }
                }
              })
              if (sam_arr.length > 0) {
                this.data = sam_arr;

              }
            }
            else {
              this.data = data['value'];
            }
            this.resetArca = true;
          } else {
            this.resetArca = false;
          }
        } else {
          this.resetArca = false;
        }
        this.arcaSrchWait = false;
        this.arcaSrchnoresults = false;
      },
        _err => {
          this.data = [];
          this.resetArca = false;
          this.arcaSrchWait = false;
          this.arcaSrchnoresults = true;
        });
    } else if (FilterParam != '' && firstAndLast === true) {
      this.arcaSrchnoresults = false;
      this.arcaSrchWait = true;
      this.isaRoleFor_Uid = [];
      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person?$filter=${FilterParam}&$select=Uid,CommonName,FirstName,LastName,Mail,PersonSuperDomainCode`).subscribe(data => {
        console.info(data);
        if (data['value'].length > 0) {
          if (this.arcasearchModel === 'sam' || this.arcasearchModel === 'buyeraasis') {
            data['value'].forEach(e => {
              if (e.PersonSuperDomainCode === 'renault' || e.PersonSuperDomainCode === 'nna' || e.PersonSuperDomainCode === 'ne' || e.PersonSuperDomainCode === 'nml') {
                if (e.LastName != undefined) {
                  if (e.LastName.toLowerCase().includes(this.ArcLastName.toLowerCase())) {
                    sam_arr.push(e);
                  }
                  if (this.showUidDisable === false && this.isEnvQua === false && this.isEnvInt === false) {
                    this.getArcaUserIsaRole(e.Uid);
                  } else if (this.isEnvQua === true || this.isEnvInt === true) {
                    this.isaRoleFor_Uid[e.Uid] = 'manager';
                  }
                }
              }
            });
            console.info("sam_arr", sam_arr);
            if (sam_arr.length > 0) {
              this.data = sam_arr;
              this.resetArca = true;
              this.arcaSrchWait = false;
              this.arcaSrchnoresults = false;
            } else {
              console.info("data null, search lastname", this.data);
              this.seacrhLastname();
            }
          }
          else {
            this.data = data['value'];
          }
        } else {
          this.resetArca = false;
        }
      },
        _err => {
          this.data = [];
          this.resetArca = false;
          this.arcaSrchWait = false;
          this.arcaSrchnoresults = true;
        });
    } else if (this.ArcIpn != "") {
      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${this.ArcIpn}')`).subscribe((data: any) => {
        if (data != null) {
          if (this.arcasearchModel === 'sam' || this.arcasearchModel === 'buyeraasis') {
            if (data.PersonSuperDomainCode === 'renault' || data.PersonSuperDomainCode === 'nna' || data.PersonSuperDomainCode === 'ne' || data.PersonSuperDomainCode === 'nml') {
              if (data.Uid != undefined) {
                if (data.Uid.toLowerCase().includes(this.ArcIpn.toLowerCase())) {
                  sam_arr.push(data);
                }
                if (this.showUidDisable === false && this.isEnvQua === false && this.isEnvInt === false) {
                  this.getArcaUserIsaRole(data.Uid);
                } else if (this.isEnvQua === true || this.isEnvInt === true) {
                  this.isaRoleFor_Uid[data.Uid] = 'manager';
                }
              }
            }
            if (sam_arr.length > 0) {
              this.data = sam_arr;
              this.resetArca = true;
              this.arcaSrchWait = false;
              this.arcaSrchnoresults = false;
            } else {
              this.data.push(data);
            }
          }
          else {
            this.data.push(data);
          }
        } else {
          this.resetArca = false;
        }

      });

    }
    else {
      console.info("Please fill anyone to search");

    }
  }
  seacrhLastname() {
    let sam_arr: any = [];
    this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person?$filter=contains(LastName,'${this.ArcLastName}') &$select=Uid,CommonName,FirstName,LastName,Mail,PersonSuperDomainCode`).subscribe(data => {
      console.info(data);
      if (data['value'] != null && data['value'] != undefined) {
        if (data['value'].length > 0) {
          if (this.arcasearchModel === 'sam' || this.arcasearchModel === 'buyeraasis') {
            data['value'].forEach(e => {
              if (e.PersonSuperDomainCode === 'renault' || e.PersonSuperDomainCode === 'nna' || e.PersonSuperDomainCode === 'ne' || e.PersonSuperDomainCode === 'nml') {
                if (e.FirstName != undefined) {
                  if (e.FirstName.toLowerCase().includes(this.ArcFirstName.toLowerCase())) {
                    sam_arr.push(e);
                  }
                  if (this.showUidDisable === false && this.isEnvQua === false && this.isEnvInt === false) {
                    this.getArcaUserIsaRole(e.Uid);
                  } else if (this.isEnvQua === true || this.isEnvInt === true) {
                    this.isaRoleFor_Uid[e.Uid] = 'manager';
                  }
                }
              }
            });
            console.info("sam_arr", sam_arr);
            if (sam_arr.length > 0) {
              this.data = sam_arr;
              this.resetArca = true;
              this.arcaSrchWait = false;
              this.arcaSrchnoresults = false;
            } else {
              this.arcaSrchnoresults = true;
              this.arcaSrchWait = false;
            }
          }
          else {
            this.data = data['value'];
          }
        } else {
          this.resetArca = false;
        }
      } else {
        this.resetArca = false;
      }
    },
      _err => {
        this.data = [];
        this.resetArca = false;
        this.arcaSrchWait = false;
        this.arcaSrchnoresults = true;
      });
  }
  getArcaUserIsaRole(ipn) {
    if (ipn != '') {
      this.arcaService.getrole(`${this.Config.ApiArcaURL}Role?$filter=(ApplicationDomain eq 'FRA') and (ApplicationId eq 'ISA') and (Uid eq '${ipn}')`).subscribe(data => {
        if (data != null) {
          if (data['value']) {
            data['value'].forEach(e => {
              this.isaRoleFor_Uid[ipn] = e.CommonName.toLowerCase();
            });
          }
        }
        console.info('roles in isa', this.isaRoleFor_Uid);
      }, error => {
        if (error.status === HTTP_STATUS_NOT_FOUND) {
          this.isaRoleFor_Uid[ipn] = 'norole';
        }
      });
    }
  }
  resetSendReqToSupp(fieEld) {
    if (fieEld === "senReqSamMOdel") {
      this.senReqSamMOdel = "";
      this.senReqSamMOdelError = true;
    } else if (fieEld === "senReqNotesMOdel") {
      this.senReqNotesMOdel = "";
    }
  }
  lookupArca(model) {
    this.arcasearchModel = model;
    this.resetArca = false;
    this.ArcIpn = "";
    this.ArcFirstName = "";
    this.ArcLastName = "";
    this.arcaSrchWait = false;
    if (model === 'sam') {
      this.showUidDisable = false;
    } else {
      this.showUidDisable = true;
    }
  }
  sendMailFn(mailTo, mailSubject, mailBody, isload = false) {
    let mailcontent: any = {};
    mailcontent.toAddress = mailTo,
      mailcontent.mailSubject = mailSubject,
      mailcontent.body = mailBody
    let baseUrl1 = baseUrl === localUrl ? intUrl : baseUrl
    this.http.post(`${baseUrl1}/api/sendMail`, mailcontent).subscribe(_data => {
      if (isload) {
        this.getSearch();
        this.validatingWorkflow = false;
        document.getElementById('closeWorkflowRejection').click();
        document.getElementById('closeWorkflowInfoRequest').click();
        document.getElementById('closeWorkflowValidation').click();
      }
      document.getElementById("closeCCBtn").click()
    });
  }
  updatemailModelName(comment, _folio, reqId, days,detail) {
    this.workflowReqIdFromK2Isa = reqId;
    this.differenceinDays = days
    this.currentModalDetail = detail;
    this.approverEmail = '';
    let idpToken = localStorage.getItem('IDPAccessToken');
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length > 0) {
        this.k2Service.getK2Isa(`${this.Config.ApiK2Url}isa/${reqId}`).subscribe(data => {
          data1.forEach(ele1 => {
            if (data['folio']) {
              if (ele1['folio'].includes(data['folio'])) {
                let workflowOwner = ele1['locatedUser'].split(":");
                this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
                  if (data7['Mail'] != undefined && data7['Mail'] != '') {
                    this.approverEmail = data7['Mail'];
                  }
                });
              }
            }
          });
        });
      }
    });
    console.info("req", reqId)
    console.info("req", comment)

  }

  sendblueRequestForMailToApp() {
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.commonService.clearAllActiveTask();
    this.k2Socle.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      this.commonService.setAllActiveTask(data1);
      if (data1.length > 0) {
        this.k2Socle.getK2IsabyId(`${this.Config.ApiK2Url}isa/${this.workflowReqIdFromK2Isa}`).subscribe(data => {
          data1.forEach(ele1 => {
            if (data['folio']) {
              if (ele1['folio'].includes(data['folio'])) {
                let workflowOwner = ele1['locatedUser'].split(":");
                if (this.personArray.findIndex(x => x.Uid.toLowerCase() === workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()) === -1) {

                  this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
                    if (data7 != null) {
                      this.personArray.push(data7);
                    }
                    console.info('personarray1', this.personArray)
                    let workflowOwnerName = '';
                    let workflowOwnerMailId = '';
                    if (data7['FirstName'] != undefined) {
                      workflowOwnerName = `${data7['FirstName']} ${data7['LastName']}`;
                    } else {
                      workflowOwnerName = workflowOwner[1];
                    }
                    if (data7['Mail'] != undefined && data7['Mail'] != '') {
                      workflowOwnerMailId = data7['Mail'];
                    }
                    console.info("owner", workflowOwnerName)
                    console.info("mailid", workflowOwnerMailId)
                    let sendMailTo = workflowOwnerMailId;
                    let mailSubject = `${this.commonService.mailSub}Approval request for ${data['supplierName']}`;
                    console.info("sub", mailSubject)
                    let onlineHelp = online
                    let style = "font-weight-bold text-warning"
                    let desc: string
                    console.info("len", data['historys'].length)
                    if (data['historys'].length === 1) {
                      desc = data['comment'];
                    }
                    else if (data['historys'].length > 1) {
                      if (data['historys'][data['historys'].length - 1]['comment'] != null || data['historys'][data['historys'].length - 1]['comment'] != '') {
                        desc = data['historys'][data['historys'].length - 1]['route'].trim() != "Submitted" ?
                          data['historys'][data['historys'].length - 1]['comment'] : data['historys'][data['historys'].length - 2]['comment']
                      }
                    }
                    let baseUrl1 = baseUrl
                    let roleTemp;
                    if (data['validatorRole'] != null || data['validatorRole'] != '') {
                      roleTemp = ` as ${data['validatorRole']}`;
                    } else {
                      roleTemp = '';
                    }
                    this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${data['allianceId']}*&_page= 1&_pagesize= 20`).subscribe(companyData => {
                      let specificLink = `${baseUrl1}/company-details/${companyData['companies'][0].rowId}#workflows`;

                      this.mailBodyContent =
                        `<p>Hello ${workflowOwnerName},</p><p> This is a kind reminder as the request ${data['folio']} (${data['strRequestType']}) is waiting for your validation ${roleTemp}  from ${this.differenceinDays} days ago! </p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from previous approver : </p><p>${desc}<p class=${style}>Notes from the reminderer:  </p><p>${this.MailNameModel}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
                      console.info("body", this.mailBodyContent)
                      this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent);
                    });
                  });
                } else {
                  let personIndex = this.personArray.findIndex(x => x.Uid.toLowerCase() === workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase())
                  let data7 = this.personArray[personIndex];
                  let workflowOwnerName = '';
                  let workflowOwnerMailId = '';
                  if (data7['FirstName'] != undefined) {
                    workflowOwnerName = `${data7['FirstName']} ${data7['LastName']}`;
                  } else {
                    workflowOwnerName = workflowOwner[1];
                  }
                  if (data7['Mail'] != undefined && data7['Mail'] != '') {
                    workflowOwnerMailId = data7['Mail'];
                  }
                  console.info("owner", workflowOwnerName)
                  console.info("mailid", workflowOwnerMailId)
                  let sendMailTo = workflowOwnerMailId;
                  let mailSubject = `${this.commonService.mailSub}Approval request for ${data['supplierName']}`;
                  console.info("sub", mailSubject)
                  let onlineHelp = online
                  let style = "font-weight-bold text-warning"
                  let desc: string
                  console.info("len", data['historys'].length)
                  if (data['historys'].length === 1) {
                    desc = data['comment'];
                  }
                  else if (data['historys'].length > 1) {
                    if (data['historys'][data['historys'].length - 1]['comment'] != null || data['historys'][data['historys'].length - 1]['comment'] != '') {
                      desc = data['historys'][data['historys'].length - 1]['route'].trim() != "Submitted" ?
                        data['historys'][data['historys'].length - 1]['comment'] : data['historys'][data['historys'].length - 2]['comment']
                    }
                  }
                  let baseUrl1 = baseUrl
                  let roleTemp;
                  if (data['validatorRole'] != null || data['validatorRole'] != '') {
                    roleTemp = ` as ${data['validatorRole']}`;
                  } else {
                    roleTemp = '';
                  }
                  this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${data['allianceId']}*&_page= 1&_pagesize= 20`).subscribe(companyData => {
                    let specificLink = `${baseUrl1}/company-details/${companyData['companies'][0].rowId}#workflows`;

                    this.mailBodyContent =
                      `<p>Hello ${workflowOwnerName},</p><p> This is a kind reminder as the request ${data['folio']} (${data['strRequestType']}) is waiting for your validation ${roleTemp}  from ${this.differenceinDays} days ago! </p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from previous approver : </p><p>${desc}<p class=${style}>Notes from the reminderer:  </p><p>${this.MailNameModel}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
                    this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent);
                  });
                }
              }
            }
          });
        }, error => {
          console.info('error', error);
        });
      }
    }, error => {
      console.info('error', error);
    });
    document.getElementById("closeCCBtnReminder").click()
  }

  resetWkfRejNotesModel() {
    this.wkfRejNotesModel = '';
  }

  rejectWkfNoteRoute() {
    this.validatingWorkflow = true;
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    if (this.wkfRejNotesModel != '') {
      this.commonService.clearAllActiveTask();
      this.k2Socle.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
        let folioPresent = false
        this.commonService.setAllActiveTask(data1);
        if (data1.length > 0) {
          data1.forEach(ele1 => {
            if (this.workflowFolioFromK2Isa) {
              if (ele1['folio'].includes(this.workflowFolioFromK2Isa)) {
                folioPresent = true
                let serialNumber = ele1['serialNumber'];
                let workflowOwner = ele1['locatedUser'].split(":");
                let temp = workflowOwner[1].split("\\");
                if (temp[1].toLowerCase() === this.Uid) {
                  let domain = temp[0];
                  let note = this.wkfRejNotesModel;
                  let encoded = encodeURIComponent(note);
                  this.k2Socle.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=Refuse&domain=${domain}`, {}).subscribe(_data => { // doubt
                    this.workflowValidationLoading = true;
                    setTimeout(() => {
                      this.sendMailToRequestor(this.workflowFolioFromK2Isa, note)
                      this.sendRequestForMailToApp(this.workflowFolioFromK2Isa, note);
                    }, THREE_THOUSAND_MS);
                  });
                }
              }
            }
          });
          if (!folioPresent) {
            setTimeout(() => {
              this.rejectWkfNoteRoute();
            }, THREE_THOUSAND_MS)
          }
        }
      }, error => {
        console.info('error', error);
      });
    } else {
      this.rejectWorkflowNotesError = true;
    }
  }

  checkCommentsField() {
    if (this.wkfRejNotesModel === '') {
      this.rejectWorkflowNotesError = true;
    } else {
      this.rejectWorkflowNotesError = false;
    }
  }

  resetWkfInfoNotesModel() {
    this.wkfInfoNotesModel = '';
  }

  infoWkfNoteRoute() {
    this.validatingWorkflow = true;
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.commonService.clearAllActiveTask();
    this.k2Socle.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      let infoFolioPresent = false
      this.commonService.setAllActiveTask(data1);
      if (data1.length > 0) {
        data1.forEach(ele1 => {
          if (this.workflowFolioFromK2Isa) {
            if (ele1['folio'].includes(this.workflowFolioFromK2Isa)) {
              infoFolioPresent = true
              let serialNumber = ele1['serialNumber'];
              let workflowOwner = ele1['locatedUser'].split(":");
              let temp = workflowOwner[1].split("\\");
              if (temp[1].toLowerCase() === this.Uid) {
                let domain = temp[0];
                let encoded = encodeURIComponent(this.wkfInfoNotesModel);
                this.k2Socle.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=More info needed&domain=${domain}`, {}).subscribe(_data => { //doubt
                  this.workflowValidationLoading = true;
                  setTimeout(() => {
                    this.sendRequestForMailToApp();
                  }, THREE_THOUSAND_MS);
                });
              }
            }
          }
        });
        if (!infoFolioPresent) {
          setTimeout(() => {
            this.infoWkfNoteRoute();
          }, THREE_THOUSAND_MS)
        }
      }
    }, error => {
      console.info('error', error);
    });
  }

  toggleApproverEdit() {
    this.approverEdit = !this.approverEdit;
  }

  notesHistoryOpen(request, type = '', page = 1) {
    console.info('dddddd', request)
    this.approverEdit = type === 'edit' ? true : false;
    this.senReqNotesMOdel = ''
    this.senReqSamMOdel = ''
    this.history = '';
    this.requestForNotesHistory = [];
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.historyLoading = true;
    this.k2Socle.getK2IsabyId(`${this.Config.ApiK2Url}isa/${request['requestId']}`).subscribe(data => {
      this.historyLoading = false;
      let roleTemp;
      data['workflowOwnerWithRole'] = request['workflowOwnerWithRole']
      data['taskID'] = request['taskID']
      data['companyId'] = request['companyId']
      data['RequestorMailId'] = request['RequestorMailId']
      if (data['validatorRole'] != null || data['validatorRole'] != '') {
        roleTemp = data['validatorRole'];
      } else {
        roleTemp = '';
      }
      if (request['workflowOwnerWithRole'].length > 0) {
        data['approver'] = `${request['workflowOwnerWithRole'][0]} (${roleTemp})`;
      } else {
        data['approver'] = '';
      }
      let notsubmitted = false;
      let temp = [];
      data['historys'].forEach(element => {
        if (element.route === "Submitted" && notsubmitted === false) {
          temp.push(element);
          notsubmitted = true;
        } else if (element.route != "Submitted") {
          temp.push(element);
        }
      });
      data['historys'] = temp;
      this.requestForNotesHistory = data;
      console.info('temp', this.requestForNotesHistory)
      this.histPager = this.pagerService.getPager(this.requestForNotesHistory['historys'].length, page, TEN);
      this.requestForNotesHistory['historys'].slice(this.histPager.startIndex, this.histPager.endIndex + 1);
      this.history = this.requestForNotesHistory['historys'].length > TEN ? false : true
    })
  }

  approverColor(a) {
    if (a[0].length === SEVEN) {
      let mystyle = {
        'color': '#cb4b32'
      }
      return mystyle
    }
  }

  historyTable(page) {
    this.histPager = this.pagerService.getPager(this.requestForNotesHistory['historys'].length, page, TEN);
    this.requestForNotesHistory['historys'].slice(this.histPager.startIndex, this.histPager.endIndex + 1);
  }
  resetCompanyNameFields() {
    this.MailNameModel = '';
  }

  ExportTOExcel() {
    let exportTo = [];
    this.workFlowExport.forEach(ele => {
      let obj = {};
      obj['Request Id'] = ele.requestId;
      obj['Supplier'] = ele.supplierName;
      obj['Requestor'] = ele.requestor.displayName;
      obj['Requestor Mailid'] = ele.RequestorMailId;
      obj['Approver'] = ele.workflowOwnerWithRole[0];
      obj['Request Type'] = ele.strRequestType;
      obj['Notes'] = ele.comment;
      obj['Date'] = this.datePipe.transform(ele.lastModificationDate, 'yyyy/MM/dd');
      obj['Status'] = ele.status;
      obj['Delay'] = ele.difference ? `(${ele.difference}d)` : '';
      exportTo.push(obj);
    });
    console.info('obj', exportTo);
    let todayDate = new Date();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportTo);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Export');
    XLSX.writeFile(wb, `export${todayDate.getTime()}.xlsx`);
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  copyAccessToken() {
    let accessToken = localStorage.getItem('IDPAccessToken');
    this.commonService.copyToClipboard(accessToken)
  }
}